var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 15,
    viewBox: "0 0 9 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.094 7.75704C0.827718 7.49076 0.827718 7.05904 1.094 6.79276L7.41215 0.474611C7.67843 0.208333 8.11015 0.208333 8.37643 0.474611C8.6427 0.740888 8.6427 1.17261 8.37643 1.43889L2.54041 7.2749L8.37643 13.1109C8.6427 13.3772 8.6427 13.8089 8.37643 14.0752C8.11015 14.3415 7.67843 14.3415 7.41215 14.0752L1.094 7.75704Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.b564b27128e006ca700e8614596ec4da.svg";
export { ForwardRef as ReactComponent };